import Connect from './Connect/Connect';
import Select from './Select/Select';
import Crud from './Crud/Crud';
import { types } from './types';

function Actions(action, showAlert, variables, setOpenVariable, variableRender) {
    switch (action.actionName) {
        case types.CONNECT: return <Connect action={action} showAlert={showAlert} variables={variables} setOpenVariable={setOpenVariable}/>;
        case types.SELECT: return <Select action={action} showAlert={showAlert} variables={variables} setOpenVariable={setOpenVariable} variableRender={variableRender}/>;
        case types.CRUD:
        case types.DELETE: return <Crud action={action} showAlert={showAlert} variables={variables} setOpenVariable={setOpenVariable} variableRender={variableRender}/>;
        default: break;
    }
}

export default Actions;
